/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_ParametersInputs */



/**
* | output |
* | --- |
* | "Apply parameters" |
*
* @param {Apply_ParametersInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const apply_parameters = /** @type {((inputs?: Apply_ParametersInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_ParametersInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Apply parameters")
	return /** @type {LocalizedString} */ ("Appliquer les paramètres")
});